import React from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';

// On the slot, for the hovered parent to reveal its chip:
// `:hover > .${DRAG_CHIP_CLASS} > *` takes DRAG_CHIP_REVEALED_CSS
export const DRAG_CHIP_CLASS = 'studio-drag-chip';
export const DRAG_CHIP_REVEALED_CSS = `
  opacity: 1;
`;

// Above its parent's top edge (or inside it, where there's no room above)
const Slot = styled.div<{ $isInside: boolean; $left: number }>`
  position: absolute;
  ${(props) => (props.$isInside ? 'top: 0;' : 'bottom: 100%;')}
  left: ${(props) => props.$left}px;
  z-index: 3;
  pointer-events: none;
`;

// Set as the selected block's tab is (see StudioCanvas), in grey, with the
// drag icon and a hint. Hidden until revealed, then shown at once.
const Chip = styled.div<{ $isInside: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: ${(props) =>
    props.$isInside ? '0 0 4px 4px' : '4px 4px 0 0'};
  background: var(--color-studio-drag-chip-bg);
  color: var(--color-studio-drag-chip-text);
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  white-space: nowrap;
  opacity: 0;
`;

// A tab on something that can be dragged, or selected to edit it (a block
// on the canvas, an element of a selected Grouped block), shown while it's
// hovered
const DragChip = ({
  left,
  label = 'Drag or select to edit',
  isInside = false,
  className,
  testId,
}: {
  left: number;
  // Naming what's dragged where it isn't clear (a row, not its cells)
  label?: string;
  isInside?: boolean;
  className?: string;
  testId: string;
}) => (
  <Slot
    className={[DRAG_CHIP_CLASS, className].filter(Boolean).join(' ')}
    $isInside={isInside}
    $left={left}
    aria-hidden
  >
    <Chip $isInside={isInside} data-testid={testId}>
      <Icon icon="drag" color="currentColor" width={12} height={12} />
      {label}
    </Chip>
  </Slot>
);

export default DragChip;
